/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023, 2024.
 */

import { SxProps } from '@mui/material';

export const productCardContentSX: SxProps = {
	px: '5px',
	py: 0,
	flex: '1',
	my: '5px',
};
